import { darken, DEFAULT_THEME } from '@mantine/core';

export const SEVERITY_COLOR_PALETTE: Record<number, string> = {
  1: DEFAULT_THEME.colors.blue[6],
  2: darken(DEFAULT_THEME.colors.green[6], 0.2),
  3: DEFAULT_THEME.colors.yellow[5],
  4: DEFAULT_THEME.colors.red[9],
  5: darken(DEFAULT_THEME.colors.red[9], 0.35),
  6: DEFAULT_THEME.colors.orange[8],
};